import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2c135e27")

_pushScopeId("data-v-2c135e27")
const _hoisted_1 = { class: "columns is-multiline are-thirds" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Distributor", -1)
const _hoisted_3 = { class: "is-expanded" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Rep", -1)
const _hoisted_5 = { class: "is-expanded" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Requestor", -1)
const _hoisted_7 = { class: "is-expanded" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Customer", -1)
const _hoisted_9 = { class: "is-expanded" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Application Detail", -1)
const _hoisted_11 = { class: "is-expanded" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Program / Project Name", -1)
const _hoisted_13 = { class: "is-expanded" }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Country", -1)
const _hoisted_15 = { class: "is-expanded" }
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "label" }, "State", -1)
const _hoisted_17 = { class: "is-expanded" }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Postal Code", -1)
const _hoisted_19 = { class: "is-expanded" }
const _hoisted_20 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Part", -1)
const _hoisted_21 = { class: "is-expanded" }
const _hoisted_22 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Registration Type", -1)
const _hoisted_23 = { class: "is-expanded" }
const _hoisted_24 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Incentive Program", -1)
const _hoisted_25 = { class: "is-expanded" }
const _hoisted_26 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Market", -1)
const _hoisted_27 = { class: "is-expanded" }
const _hoisted_28 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Previous Registration ID", -1)
const _hoisted_29 = { class: "is-expanded" }
const _hoisted_30 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Distributor Internal Reference", -1)
const _hoisted_31 = { class: "is-expanded" }
const _hoisted_32 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Start of Production", -1)
const _hoisted_33 = { class: "is-expanded" }
const _hoisted_34 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Estimated Annual Units", -1)
const _hoisted_35 = { class: "is-expanded" }
const _hoisted_36 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Target Distribution Buy Price", -1)
const _hoisted_37 = { class: "is-expanded is-flex" }
const _hoisted_38 = /*#__PURE__*/_createVNode("span", { class: "icon is-left" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-dollar-sign" })
], -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Target Resale Price", -1)
const _hoisted_40 = { class: "is-expanded is-flex" }
const _hoisted_41 = /*#__PURE__*/_createVNode("span", { class: "icon is-left" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-dollar-sign" })
], -1)
const _hoisted_42 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Design Value", -1)
const _hoisted_43 = { class: "is-expanded is-flex" }
const _hoisted_44 = /*#__PURE__*/_createVNode("span", { class: "icon is-left" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-dollar-sign" })
], -1)
const _hoisted_45 = { class: "label is-inline-flex" }
const _hoisted_46 = /*#__PURE__*/_createVNode("span", null, " Distributor Book Cost ", -1)
const _hoisted_47 = /*#__PURE__*/_createVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-info-circle" })
], -1)
const _hoisted_48 = {
  key: 0,
  class: "is-expanded is-flex"
}
const _hoisted_49 = /*#__PURE__*/_createVNode("span", { class: "icon is-left" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-dollar-sign" })
], -1)
const _hoisted_50 = {
  key: 1,
  class: "is-expanded is-flex"
}
const _hoisted_51 = /*#__PURE__*/_createVNode("span", { class: "has-text-danger has-text-weight-bold" }, " Not Set ", -1)
const _hoisted_52 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Expiration Date", -1)
const _hoisted_53 = { class: "is-expanded" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_tooltip = _resolveComponent("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", null, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.registrationDetail?.distributorName || "---"), 1)
    ]),
    _createVNode("div", null, [
      _hoisted_4,
      _createVNode("div", _hoisted_5, _toDisplayString(_ctx.registrationDetail?.salesRepName || "---"), 1)
    ]),
    _createVNode("div", null, [
      _hoisted_6,
      _createVNode("div", _hoisted_7, [
        _createVNode("span", null, _toDisplayString(_ctx.registrationDetail?.requestorUserDisplayName || "---"), 1)
      ])
    ]),
    _createVNode("div", null, [
      _hoisted_8,
      _createVNode("div", _hoisted_9, [
        _createVNode("span", null, _toDisplayString(_ctx.registrationDetail?.customerName || "---"), 1)
      ])
    ]),
    _createVNode("div", null, [
      _hoisted_10,
      _createVNode("div", _hoisted_11, [
        _createVNode("span", null, _toDisplayString(_ctx.registrationDetail?.applicationName || "---"), 1)
      ])
    ]),
    _createVNode("div", null, [
      _hoisted_12,
      _createVNode("div", _hoisted_13, [
        _createVNode("span", null, _toDisplayString(_ctx.registrationDetail?.projectName || "---"), 1)
      ])
    ]),
    _createVNode("div", null, [
      _hoisted_14,
      _createVNode("div", _hoisted_15, [
        _createVNode("span", null, _toDisplayString(_ctx.registrationDetail?.countryName || "---"), 1)
      ])
    ]),
    _createVNode("div", null, [
      _hoisted_16,
      _createVNode("div", _hoisted_17, [
        _createVNode("span", null, _toDisplayString(_ctx.registrationDetail?.state || "---"), 1)
      ])
    ]),
    _createVNode("div", null, [
      _hoisted_18,
      _createVNode("div", _hoisted_19, [
        _createVNode("span", null, _toDisplayString(_ctx.registrationDetail?.postalCode || "---"), 1)
      ])
    ]),
    _createVNode("div", null, [
      _hoisted_20,
      _createVNode("div", _hoisted_21, [
        _createVNode("span", null, _toDisplayString(_ctx.registrationDetail?.partName || "---"), 1)
      ])
    ]),
    _createVNode("div", null, [
      _hoisted_22,
      _createVNode("div", _hoisted_23, [
        _createVNode("span", null, _toDisplayString(_ctx.registrationDetail?.typeName || "---"), 1)
      ])
    ]),
    _createVNode("div", null, [
      _hoisted_24,
      _createVNode("div", _hoisted_25, [
        _createVNode("span", null, _toDisplayString(_ctx.registrationDetail?.incentiveProgramName || "None"), 1)
      ])
    ]),
    _createVNode("div", null, [
      _hoisted_26,
      _createVNode("div", _hoisted_27, [
        _createVNode("span", null, _toDisplayString(_ctx.registrationDetail?.marketGroupName || "---"), 1)
      ])
    ]),
    _createVNode("div", null, [
      _hoisted_28,
      _createVNode("div", _hoisted_29, [
        _createVNode("span", null, _toDisplayString(_ctx.registrationDetail?.prevRegistrationNumber || "---"), 1)
      ])
    ]),
    _createVNode("div", null, [
      _hoisted_30,
      _createVNode("div", _hoisted_31, [
        _createVNode("span", null, _toDisplayString(_ctx.registrationDetail?.distributorInternalReference || "---"), 1)
      ])
    ]),
    _createVNode("div", null, [
      _hoisted_32,
      _createVNode("div", _hoisted_33, [
        _createVNode("span", null, _toDisplayString(_ctx.formatDate(_ctx.registrationDetail?.startOfProduction)), 1)
      ])
    ]),
    _createVNode("div", null, [
      _hoisted_34,
      _createVNode("div", _hoisted_35, [
        _createVNode("span", null, _toDisplayString(_ctx.formatNumber(_ctx.registrationDetail?.estimatedAnnualUnits) || "---"), 1)
      ])
    ]),
    _createVNode("div", null, [
      _hoisted_36,
      _createVNode("div", _hoisted_37, [
        _hoisted_38,
        _createVNode("span", null, _toDisplayString(_ctx.formatNumber(_ctx.registrationDetail?.targetDistributionBuyPrice, 4) || "---"), 1)
      ])
    ]),
    _createVNode("div", null, [
      _hoisted_39,
      _createVNode("div", _hoisted_40, [
        _hoisted_41,
        _createVNode("span", null, _toDisplayString(_ctx.formatNumber(_ctx.registrationDetail?.targetResalePrice, 4) || "---"), 1)
      ])
    ]),
    _createVNode("div", null, [
      _hoisted_42,
      _createVNode("div", _hoisted_43, [
        _hoisted_44,
        _createVNode("span", null, _toDisplayString(_ctx.formatNumber(_ctx.registrationDetail?.designValue, 0) || "---"), 1)
      ])
    ]),
    _createVNode("div", null, [
      _createVNode("span", _hoisted_45, [
        _hoisted_46,
        _createVNode(_component_tooltip, {
          class: "cost-icon is-inline ml-2",
          content: _ctx.tooltipContent,
          position: 'bottom',
          filter: 'span'
        }, {
          default: _withId(() => [
            _hoisted_47
          ]),
          _: 1
        }, 8, ["content"])
      ]),
      (_ctx.registrationDetail?.distributorBookCost)
        ? (_openBlock(), _createBlock("div", _hoisted_48, [
            _hoisted_49,
            _createVNode("span", null, _toDisplayString(_ctx.formatNumber(_ctx.registrationDetail?.distributorBookCost, 4) || "---"), 1)
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_50, [
            _hoisted_51
          ]))
    ]),
    _createVNode("div", null, [
      _hoisted_52,
      _createVNode("div", _hoisted_53, [
        _createVNode("span", null, _toDisplayString(_ctx.expirationDate), 1)
      ])
    ])
  ]))
})